import React, { useState, useEffect,useContext } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import $ from 'jquery';
import { MyContext } from './MyContextProvider'; // Import your context
import { useParams,useNavigate  } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import './PREAUCT_Pre_Auction_Pool_S.css';

const PREAUCT_Pre_Auction_Pool_S = (props) => {
  const { i18n } = useTranslation();
  const { t } = useTranslation();
  var location = useLocation();
  const { App_Data, setApp_Data } = useContext(MyContext); // Access the context
  const urlParams = new URLSearchParams(window.location.search);
  //setReturn_Path(urlParams.get('Return'));
  const navigate = useNavigate();
  let selectedData ="";
  
  const inputFontStyle = {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000'
  };



  

  useEffect(() => {
    document.title = "SRWAE | "+t('Pre-Auction Pool');  

 const handleReturn = async () => {
    const collectClientInfo = () => {
      return {
        userAgent: navigator.userAgent,
        language: navigator.language,
        platform: navigator.platform,
        screenResolution: `${screen.width}x${screen.height}`,
        colorDepth: screen.colorDepth,
        timezoneOffset: new Date().getTimezoneOffset(),
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        cookieEnabled: navigator.cookieEnabled,
        javaEnabled: navigator.javaEnabled(),
        online: navigator.onLine,
        referrer: document.referrer,
        locationHref: window.location.href,
        screenOrientation: screen.orientation?.type || 'unknown'
      };
    };

    const clientInfo = collectClientInfo();

    try {
      const response = await fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREAUCT_PRE_AUCTION_POOL/Select', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ data: App_Data.Data, clientInfo: clientInfo, stamp: Date.now() })
      });

      if (response.ok) {
        navigate('/PREAUCT_Pre_Auction_Pool', { replace: true });
      } else {
        console.error("Select call failed with status:", response.status);
      }
    } catch (err) {
      console.error("Select fetch error:", err);
    }
  };	  
	  
	for (let i = 1; i <= 1; i++) {
	  const sectionId = `#PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_${i}_SECTION`;
	  const headerId = `#PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_${i}_HEADER`;

	  if ($(sectionId).length && $(headerId).length) {
		
		const hiddenSections = [1];
		if (hiddenSections.includes(i)) {
		  $(sectionId).hide();
		} else {
		  $(sectionId).show();
		}

		$(headerId).off("click").on("click", function () {
		  $(sectionId).slideToggle();

		  const icon = $(this).find(".toggle-icon");
		  const current = icon.text().trim();

		  if (current === "v") {
			icon.text("^");
		  } else {
			icon.text("v");
		  }
		});
	  }
	}
	
	const searchInput = $('input[type="search"]');
 	const Temp_Search = App_Data["Object_Search"];
	if(Temp_Search!=""){
		searchInput.val(Temp_Search);
	}

	if(location.hash=="#Return"){
		const collectClientInfo = () => {
		return {
			userAgent: navigator.userAgent,
			language: navigator.language,
			platform: navigator.platform,
			screenResolution: `${screen.width}x${screen.height}`,
			colorDepth: screen.colorDepth,
			timezoneOffset: new Date().getTimezoneOffset(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			cookieEnabled: navigator.cookieEnabled,
			javaEnabled: navigator.javaEnabled(),
			online: navigator.onLine,
			referrer: document.referrer,
			locationHref: window.location.href,
			screenOrientation: screen.orientation?.type || 'unknown'
		  };
		};
		
		const clientInfo = collectClientInfo();

		fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREAUCT_PRE_AUCTION_POOL/Select', {
		  method: 'POST',
		  headers: { 'Content-Type': 'application/json' },
		  body: JSON.stringify({ data:(App_Data&&App_Data.Data?App_Data.Data:{id:-1}) , clientInfo:clientInfo , stamp: Date.now() })
		}).catch(err => {
		  console.error("Error", err);
		});			
		navigate('/PREAUCT_Pre_Auction_Pool',{replace:true});
	}
	if(location.hash=="#New"){
		setApp_Data({ ...App_Data});
		navigate('/PREAUCT_Pre_Auction_Pool',{replace:true});
	}
	if(location.hash=="#Search"){
		setApp_Data({ ...App_Data});
		navigate('/PREAUCT_Pre_Auction_Pool_S',{replace:true});
	}
	if(location.hash=="#Update"){
		setApp_Data({ ...App_Data});
		navigate('/PREAUCT_Pre_Auction_Pool',{replace:true});
	}
	if(location.hash=="#FormPreview"){
		setApp_Data({ ...App_Data});
		navigate('/PREAUCT_Pre_Auction_Pool_P',{replace:true});
	}
	if(location.hash=="#SearchPreview"){
		setApp_Data({ ...App_Data});
		navigate('/PREAUCT_Pre_Auction_Pool_S_P',{replace:true});
	}
	if(location.hash=="#Print"){
		setApp_Data({ ...App_Data});
		navigate('/PREAUCT_Pre_Auction_Pool_P',{replace:true});
	}
	if(location.hash=="#Delete"){
		setApp_Data({ ...App_Data});
		navigate('/PREAUCT_Pre_Auction_Pool',{replace:true});
	}
	if(location.hash=="#Export"){
		setApp_Data({ ...App_Data});
		navigate('/PREAUCT_Pre_Auction_Pool',{replace:true});
	}
	if(location.hash=="#Import"){
		setApp_Data({ ...App_Data});
		navigate('/PREAUCT_Pre_Auction_Pool',{replace:true});
	}
	if(location.hash=="#Help"){
		setApp_Data({ ...App_Data});
		navigate('/PREAUCT_Pre_Auction_Pool',{replace:true});
	}
	if(location.hash=="#LogInLogOut"){
		setApp_Data({ ...App_Data});
		navigate('/PREAUCT_Pre_Auction_Pool',{replace:true});
	}

     	    window.DataTableScript('#Table9');

  })  

  const [PREAUCT_PRE_AUCTION_POOL, setPREAUCT_PRE_AUCTION_POOL] = React.useState(null);
  const [PREAUCT_PRE_AUCTION_POOL_S, setPREAUCT_PRE_AUCTION_POOL_S] = React.useState(null);

  var Ids = [];
  for(var Ele in PREAUCT_PRE_AUCTION_POOL_S){
	  for(var Sec in PREAUCT_PRE_AUCTION_POOL_S[Ele]){
			if(Sec == "id")
				Ids.push(PREAUCT_PRE_AUCTION_POOL_S[Ele]["id"]);
			else if(Sec == "status")
				Ids.push(PREAUCT_PRE_AUCTION_POOL_S[Ele]["status"]);
			else if(Array.isArray(PREAUCT_PRE_AUCTION_POOL_S[Ele][Sec]))
				  for(var Row in PREAUCT_PRE_AUCTION_POOL_S[Ele][Sec])
					for (var Id in Row) 
						Ids.push(Id);
			else
				for (var Id in PREAUCT_PRE_AUCTION_POOL_S[Ele][Sec]) 
					Ids.push(Id);
	  }
  }
  
  const [isValid, setIsValid] = useState(Object.fromEntries(Ids.map(key => [key, true])));
   
   
  React.useEffect(() => {
    axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREAUCT_PRE_AUCTION_POOL`).then((response) => {
      setPREAUCT_PRE_AUCTION_POOL(response.data);
	  
		var Temp_Detail = [];
		Object.keys(response.data).map((key, index) => {
		  var Temp_Obj={};
		  var Temp_Val = JSON.parse(JSON.stringify(response.data[index]));
		  for(var Sec in Temp_Val){
		     if(Sec == "id")
						Temp_Obj["id"] = Temp_Val[Sec];
			 else if(Array.isArray(Temp_Val[Sec])){
					  for(var Row in Temp_Val[Sec])
						for (var Id in Temp_Val[Sec][Row]){ 
							if(Temp_Obj.hasOwnProperty(Id))
								Temp_Obj[Id] += "|||"+Temp_Val[Sec][Row][Id];
							else
								Temp_Obj[Id]=Temp_Val[Sec][Row][Id];
						}
			}else{
				for (var Id in Temp_Val[Sec]){ 
					Temp_Obj[Id] = Temp_Val[Sec][Id];
				}
			}
		  }
		  Temp_Detail.push(Temp_Obj);
	  })
	  //setALLFIELDS_S(JSON.parse(JSON.stringify(Temp_Detail)));	  

	setPREAUCT_PRE_AUCTION_POOL_S(JSON.parse(JSON.stringify(Temp_Detail)));
	  
	  
	  
    });
	//$('#navbarNav1').show();
//$('#navbarNav6').show();

  }, []);

  if (!PREAUCT_PRE_AUCTION_POOL_S) return <div>Loading...</div>;

 const handleLastDataPREAUCT_PRE_AUCTION_POOL_S = async (data) => {
  };




  const handleAddPREAUCT_PRE_AUCTION_POOL_S = async () => {
    try {
      await axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREAUCT_PRE_AUCTION_POOL_S', JSON.parse(JSON.stringify(PREAUCT_PRE_AUCTION_POOL_S)));

      const response = await axios.get('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREAUCT_PRE_AUCTION_POOL_S');
      setPREAUCT_PRE_AUCTION_POOL_S(response.data);
    } catch (error) {
      console.error('Error adding post:', error);
    }
  };
  

    
const PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_1_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_1_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_PRE_AUCTION_POOL_S));
	Temp_Data["1"]["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_1_0"]=value;
	//handleAddPREAUCT_PRE_AUCTION_POOL_S(Temp_Data,App_Data['PREAUCT_PRE_AUCTION_POOL_S']);
	Form_Data_onChange("1","PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_1_0",value,Temp_Data);
 	//handleLastDataPREAUCT_PRE_AUCTION_POOL_S(Temp_Data);
    setPREAUCT_PRE_AUCTION_POOL_S(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_1_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_1_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_PRE_AUCTION_POOL_S));
	Temp_Data["1"]["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_1_1"]=value;
	//handleAddPREAUCT_PRE_AUCTION_POOL_S(Temp_Data,App_Data['PREAUCT_PRE_AUCTION_POOL_S']);
	Form_Data_onChange("1","PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_1_1",value,Temp_Data);
 	//handleLastDataPREAUCT_PRE_AUCTION_POOL_S(Temp_Data);
    setPREAUCT_PRE_AUCTION_POOL_S(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_1_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_1_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_PRE_AUCTION_POOL_S));
	Temp_Data["1"]["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_1_2"]=value;
	//handleAddPREAUCT_PRE_AUCTION_POOL_S(Temp_Data,App_Data['PREAUCT_PRE_AUCTION_POOL_S']);
	Form_Data_onChange("1","PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_1_2",value,Temp_Data);
 	//handleLastDataPREAUCT_PRE_AUCTION_POOL_S(Temp_Data);
    setPREAUCT_PRE_AUCTION_POOL_S(Temp_Data);
 }; 
  

const PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_1_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_1_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_PRE_AUCTION_POOL));
	Temp_Data["1"]["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_1_3"]=value;
	Form_Data_onChange("1","PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_1_3",value,Temp_Data);
 	//handleLastDataPREAUCT_PRE_AUCTION_POOL(Temp_Data);
    setPREAUCT_PRE_AUCTION_POOL(Temp_Data);
	//handleAddPREAUCT_PRE_AUCTION_POOL(Temp_Data,App_Data['PREAUCT_PRE_AUCTION_POOL']);
  }; 
  

    
const PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_2_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_2_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_PRE_AUCTION_POOL_S));
	Temp_Data["2"]["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_2_0"]=value;
	//handleAddPREAUCT_PRE_AUCTION_POOL_S(Temp_Data,App_Data['PREAUCT_PRE_AUCTION_POOL_S']);
	Form_Data_onChange("2","PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_2_0",value,Temp_Data);
 	//handleLastDataPREAUCT_PRE_AUCTION_POOL_S(Temp_Data);
    setPREAUCT_PRE_AUCTION_POOL_S(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_2_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_2_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_PRE_AUCTION_POOL_S));
	Temp_Data["2"]["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_2_1"]=value;
	//handleAddPREAUCT_PRE_AUCTION_POOL_S(Temp_Data,App_Data['PREAUCT_PRE_AUCTION_POOL_S']);
	Form_Data_onChange("2","PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_2_1",value,Temp_Data);
 	//handleLastDataPREAUCT_PRE_AUCTION_POOL_S(Temp_Data);
    setPREAUCT_PRE_AUCTION_POOL_S(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_2_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_2_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_PRE_AUCTION_POOL_S));
	Temp_Data["2"]["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_2_2"]=value;
	//handleAddPREAUCT_PRE_AUCTION_POOL_S(Temp_Data,App_Data['PREAUCT_PRE_AUCTION_POOL_S']);
	Form_Data_onChange("2","PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_2_2",value,Temp_Data);
 	//handleLastDataPREAUCT_PRE_AUCTION_POOL_S(Temp_Data);
    setPREAUCT_PRE_AUCTION_POOL_S(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_2_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_2_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_PRE_AUCTION_POOL_S));
	Temp_Data["2"]["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_2_3"]=value;
	//handleAddPREAUCT_PRE_AUCTION_POOL_S(Temp_Data,App_Data['PREAUCT_PRE_AUCTION_POOL_S']);
	Form_Data_onChange("2","PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_2_3",value,Temp_Data);
 	//handleLastDataPREAUCT_PRE_AUCTION_POOL_S(Temp_Data);
    setPREAUCT_PRE_AUCTION_POOL_S(Temp_Data);
 }; 
  
  
      
const PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_3_0_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_3_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_PRE_AUCTION_POOL_S));
	Temp_Data["3"]["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_3_0"]=value ? true : false; // optionally just use boolean
	//handleAddPREAUCT_PRE_AUCTION_POOL_S(Temp_Data,App_Data['PREAUCT_PRE_AUCTION_POOL_S']);
	Form_Data_onChange("3","PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_3_0",value,Temp_Data);
 	//handleLastDataPREAUCT_PRE_AUCTION_POOL_S(Temp_Data);
    setPREAUCT_PRE_AUCTION_POOL_S(Temp_Data);
 }; 
  


  
      
const PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_3_1_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_3_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_PRE_AUCTION_POOL_S));
	Temp_Data["3"]["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_3_1"]=value ? true : false; // optionally just use boolean
	//handleAddPREAUCT_PRE_AUCTION_POOL_S(Temp_Data,App_Data['PREAUCT_PRE_AUCTION_POOL_S']);
	Form_Data_onChange("3","PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_3_1",value,Temp_Data);
 	//handleLastDataPREAUCT_PRE_AUCTION_POOL_S(Temp_Data);
    setPREAUCT_PRE_AUCTION_POOL_S(Temp_Data);
 }; 
  


  
      
const PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_3_2_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_3_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_PRE_AUCTION_POOL_S));
	Temp_Data["3"]["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_3_2"]=value ? true : false; // optionally just use boolean
	//handleAddPREAUCT_PRE_AUCTION_POOL_S(Temp_Data,App_Data['PREAUCT_PRE_AUCTION_POOL_S']);
	Form_Data_onChange("3","PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_3_2",value,Temp_Data);
 	//handleLastDataPREAUCT_PRE_AUCTION_POOL_S(Temp_Data);
    setPREAUCT_PRE_AUCTION_POOL_S(Temp_Data);
 }; 
  


    
const PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_4_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^\d{2}\/\d{2}\/\d{4}$/; // For DD/MM/YYYY format:
	
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_4_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_PRE_AUCTION_POOL_S));
	Temp_Data["4"]["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_4_0"]=value;
	Form_Data_onChange("4","PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_4_0",value,Temp_Data);
    setPREAUCT_PRE_AUCTION_POOL_S(Temp_Data);
  }; 
  
    
const PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_4_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^\d{2}\/\d{2}\/\d{4}$/; // For DD/MM/YYYY format:
	
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_4_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_PRE_AUCTION_POOL_S));
	Temp_Data["4"]["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_4_1"]=value;
	Form_Data_onChange("4","PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_4_1",value,Temp_Data);
    setPREAUCT_PRE_AUCTION_POOL_S(Temp_Data);
  }; 
  

const PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_4_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_4_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_PRE_AUCTION_POOL));
	Temp_Data["4"]["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_4_2"]=value;
	Form_Data_onChange("4","PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_4_2",value,Temp_Data);
 	//handleLastDataPREAUCT_PRE_AUCTION_POOL(Temp_Data);
    setPREAUCT_PRE_AUCTION_POOL(Temp_Data);
	//handleAddPREAUCT_PRE_AUCTION_POOL(Temp_Data,App_Data['PREAUCT_PRE_AUCTION_POOL']);
  }; 
  

    
const PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_5_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_5_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_PRE_AUCTION_POOL_S));
	Temp_Data["5"]["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_5_0"]=value;
	//handleAddPREAUCT_PRE_AUCTION_POOL_S(Temp_Data,App_Data['PREAUCT_PRE_AUCTION_POOL_S']);
	Form_Data_onChange("5","PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_5_0",value,Temp_Data);
 	//handleLastDataPREAUCT_PRE_AUCTION_POOL_S(Temp_Data);
    setPREAUCT_PRE_AUCTION_POOL_S(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_5_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_5_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_PRE_AUCTION_POOL_S));
	Temp_Data["5"]["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_5_1"]=value;
	//handleAddPREAUCT_PRE_AUCTION_POOL_S(Temp_Data,App_Data['PREAUCT_PRE_AUCTION_POOL_S']);
	Form_Data_onChange("5","PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_5_1",value,Temp_Data);
 	//handleLastDataPREAUCT_PRE_AUCTION_POOL_S(Temp_Data);
    setPREAUCT_PRE_AUCTION_POOL_S(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_5_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_5_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_PRE_AUCTION_POOL_S));
	Temp_Data["5"]["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_5_2"]=value;
	//handleAddPREAUCT_PRE_AUCTION_POOL_S(Temp_Data,App_Data['PREAUCT_PRE_AUCTION_POOL_S']);
	Form_Data_onChange("5","PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_5_2",value,Temp_Data);
 	//handleLastDataPREAUCT_PRE_AUCTION_POOL_S(Temp_Data);
    setPREAUCT_PRE_AUCTION_POOL_S(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_5_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_5_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_PRE_AUCTION_POOL_S));
	Temp_Data["5"]["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_5_3"]=value;
	//handleAddPREAUCT_PRE_AUCTION_POOL_S(Temp_Data,App_Data['PREAUCT_PRE_AUCTION_POOL_S']);
	Form_Data_onChange("5","PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_5_3",value,Temp_Data);
 	//handleLastDataPREAUCT_PRE_AUCTION_POOL_S(Temp_Data);
    setPREAUCT_PRE_AUCTION_POOL_S(Temp_Data);
 }; 
  

const PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_5_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_5_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_PRE_AUCTION_POOL));
	Temp_Data["5"]["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_5_4"]=value;
	Form_Data_onChange("5","PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_5_4",value,Temp_Data);
 	//handleLastDataPREAUCT_PRE_AUCTION_POOL(Temp_Data);
    setPREAUCT_PRE_AUCTION_POOL(Temp_Data);
	//handleAddPREAUCT_PRE_AUCTION_POOL(Temp_Data,App_Data['PREAUCT_PRE_AUCTION_POOL']);
  }; 
  

    
const PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_5_5_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_5_5"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_PRE_AUCTION_POOL_S));
	Temp_Data["5"]["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_5_5"]=value;
	//handleAddPREAUCT_PRE_AUCTION_POOL_S(Temp_Data,App_Data['PREAUCT_PRE_AUCTION_POOL_S']);
	Form_Data_onChange("5","PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_5_5",value,Temp_Data);
 	//handleLastDataPREAUCT_PRE_AUCTION_POOL_S(Temp_Data);
    setPREAUCT_PRE_AUCTION_POOL_S(Temp_Data);
 }; 
  
  
      
const PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_0_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_PRE_AUCTION_POOL_S));
	Temp_Data["7"]["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_0"]=value ? true : false; // optionally just use boolean
	//handleAddPREAUCT_PRE_AUCTION_POOL_S(Temp_Data,App_Data['PREAUCT_PRE_AUCTION_POOL_S']);
	Form_Data_onChange("7","PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_0",value,Temp_Data);
 	//handleLastDataPREAUCT_PRE_AUCTION_POOL_S(Temp_Data);
    setPREAUCT_PRE_AUCTION_POOL_S(Temp_Data);
 }; 
  



const PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_PRE_AUCTION_POOL));
	Temp_Data["7"]["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_1"]=value;
	Form_Data_onChange("7","PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_1",value,Temp_Data);
 	//handleLastDataPREAUCT_PRE_AUCTION_POOL(Temp_Data);
    setPREAUCT_PRE_AUCTION_POOL(Temp_Data);
	//handleAddPREAUCT_PRE_AUCTION_POOL(Temp_Data,App_Data['PREAUCT_PRE_AUCTION_POOL']);
  }; 
  


const PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_PRE_AUCTION_POOL));
	Temp_Data["7"]["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_2"]=value;
	Form_Data_onChange("7","PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_2",value,Temp_Data);
 	//handleLastDataPREAUCT_PRE_AUCTION_POOL(Temp_Data);
    setPREAUCT_PRE_AUCTION_POOL(Temp_Data);
	//handleAddPREAUCT_PRE_AUCTION_POOL(Temp_Data,App_Data['PREAUCT_PRE_AUCTION_POOL']);
  }; 
  

    
const PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_PRE_AUCTION_POOL_S));
	Temp_Data["7"]["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_3"]=value;
	//handleAddPREAUCT_PRE_AUCTION_POOL_S(Temp_Data,App_Data['PREAUCT_PRE_AUCTION_POOL_S']);
	Form_Data_onChange("7","PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_3",value,Temp_Data);
 	//handleLastDataPREAUCT_PRE_AUCTION_POOL_S(Temp_Data);
    setPREAUCT_PRE_AUCTION_POOL_S(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_PRE_AUCTION_POOL_S));
	Temp_Data["7"]["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_4"]=value;
	//handleAddPREAUCT_PRE_AUCTION_POOL_S(Temp_Data,App_Data['PREAUCT_PRE_AUCTION_POOL_S']);
	Form_Data_onChange("7","PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_4",value,Temp_Data);
 	//handleLastDataPREAUCT_PRE_AUCTION_POOL_S(Temp_Data);
    setPREAUCT_PRE_AUCTION_POOL_S(Temp_Data);
 }; 
  
  
      
const PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_5_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_5"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_PRE_AUCTION_POOL_S));
	Temp_Data["7"]["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_5"]=value ? true : false; // optionally just use boolean
	//handleAddPREAUCT_PRE_AUCTION_POOL_S(Temp_Data,App_Data['PREAUCT_PRE_AUCTION_POOL_S']);
	Form_Data_onChange("7","PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_5",value,Temp_Data);
 	//handleLastDataPREAUCT_PRE_AUCTION_POOL_S(Temp_Data);
    setPREAUCT_PRE_AUCTION_POOL_S(Temp_Data);
 }; 
  



const PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_6_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_6"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_PRE_AUCTION_POOL));
	Temp_Data["7"]["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_6"]=value;
	Form_Data_onChange("7","PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_6",value,Temp_Data);
 	//handleLastDataPREAUCT_PRE_AUCTION_POOL(Temp_Data);
    setPREAUCT_PRE_AUCTION_POOL(Temp_Data);
	//handleAddPREAUCT_PRE_AUCTION_POOL(Temp_Data,App_Data['PREAUCT_PRE_AUCTION_POOL']);
  }; 
  


const PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_7_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_7"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_PRE_AUCTION_POOL));
	Temp_Data["7"]["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_7"]=value;
	Form_Data_onChange("7","PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_7",value,Temp_Data);
 	//handleLastDataPREAUCT_PRE_AUCTION_POOL(Temp_Data);
    setPREAUCT_PRE_AUCTION_POOL(Temp_Data);
	//handleAddPREAUCT_PRE_AUCTION_POOL(Temp_Data,App_Data['PREAUCT_PRE_AUCTION_POOL']);
  }; 
  


const PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_8_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_8"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_PRE_AUCTION_POOL));
	Temp_Data["7"]["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_8"]=value;
	Form_Data_onChange("7","PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_8",value,Temp_Data);
 	//handleLastDataPREAUCT_PRE_AUCTION_POOL(Temp_Data);
    setPREAUCT_PRE_AUCTION_POOL(Temp_Data);
	//handleAddPREAUCT_PRE_AUCTION_POOL(Temp_Data,App_Data['PREAUCT_PRE_AUCTION_POOL']);
  }; 
  


const PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_9_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_9"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_PRE_AUCTION_POOL));
	Temp_Data["7"]["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_9"]=value;
	Form_Data_onChange("7","PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_9",value,Temp_Data);
 	//handleLastDataPREAUCT_PRE_AUCTION_POOL(Temp_Data);
    setPREAUCT_PRE_AUCTION_POOL(Temp_Data);
	//handleAddPREAUCT_PRE_AUCTION_POOL(Temp_Data,App_Data['PREAUCT_PRE_AUCTION_POOL']);
  }; 
  


const PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_9_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_9_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_PRE_AUCTION_POOL));
	Temp_Data["9"]["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_9_0"]=value;
	Form_Data_onChange("9","PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_9_0",value,Temp_Data);
 	//handleLastDataPREAUCT_PRE_AUCTION_POOL(Temp_Data);
    setPREAUCT_PRE_AUCTION_POOL(Temp_Data);
	//handleAddPREAUCT_PRE_AUCTION_POOL(Temp_Data,App_Data['PREAUCT_PRE_AUCTION_POOL']);
  }; 
  

    
const PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_9_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_9_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_PRE_AUCTION_POOL_S));
	Temp_Data["9"]["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_9_1"]=value;
	//handleAddPREAUCT_PRE_AUCTION_POOL_S(Temp_Data,App_Data['PREAUCT_PRE_AUCTION_POOL_S']);
	Form_Data_onChange("9","PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_9_1",value,Temp_Data);
 	//handleLastDataPREAUCT_PRE_AUCTION_POOL_S(Temp_Data);
    setPREAUCT_PRE_AUCTION_POOL_S(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_9_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_9_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_PRE_AUCTION_POOL_S));
	Temp_Data["9"]["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_9_2"]=value;
	//handleAddPREAUCT_PRE_AUCTION_POOL_S(Temp_Data,App_Data['PREAUCT_PRE_AUCTION_POOL_S']);
	Form_Data_onChange("9","PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_9_2",value,Temp_Data);
 	//handleLastDataPREAUCT_PRE_AUCTION_POOL_S(Temp_Data);
    setPREAUCT_PRE_AUCTION_POOL_S(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_9_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_9_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_PRE_AUCTION_POOL_S));
	Temp_Data["9"]["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_9_3"]=value;
	//handleAddPREAUCT_PRE_AUCTION_POOL_S(Temp_Data,App_Data['PREAUCT_PRE_AUCTION_POOL_S']);
	Form_Data_onChange("9","PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_9_3",value,Temp_Data);
 	//handleLastDataPREAUCT_PRE_AUCTION_POOL_S(Temp_Data);
    setPREAUCT_PRE_AUCTION_POOL_S(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_9_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_9_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_PRE_AUCTION_POOL_S));
	Temp_Data["9"]["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_9_4"]=value;
	//handleAddPREAUCT_PRE_AUCTION_POOL_S(Temp_Data,App_Data['PREAUCT_PRE_AUCTION_POOL_S']);
	Form_Data_onChange("9","PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_9_4",value,Temp_Data);
 	//handleLastDataPREAUCT_PRE_AUCTION_POOL_S(Temp_Data);
    setPREAUCT_PRE_AUCTION_POOL_S(Temp_Data);
 }; 
  


 
const Form_Data_onChange = (Sec,ID) => {

};


 
   const handleSingleClick = (event,ID) => {
	$(event.currentTarget).siblings().removeClass('selected');
    event.currentTarget.classList.toggle('selected');
   };


   const handleDoubleClick = (event,ID) => {
    const selectedRowId = event.currentTarget.id.replace("TR","");
	selectedData = PREAUCT_PRE_AUCTION_POOL_S.find(e => e.id == selectedRowId);
    //App_Data.Return_Data=selectedRowId;
    App_Data.Object_Return=selectedRowId;
    //console.log(event.currentTarget.querySelector('td').textContent);
    App_Data.Object_Text=selectedRowId+";"+event.currentTarget.querySelector('td').textContent;
    App_Data.Object_Id=selectedRowId;
	App_Data.Data=selectedData;
	setApp_Data({ ...App_Data})
    window.location.hash = 'Return';
   };
 
  return <>
			<nav className="navbar navbar-expand-lg navbar-light bg-light">
			 <div style={{ padding: '10px 20px', fontSize: '1.5rem', fontWeight: 'bold' }}>
			  {t('Select Pre-Auction Pool')}
			  <hr style={{ marginTop: '8px', borderTop: '2px solid #007bff', width: '100%' }} />
			</div>
			 <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			 <span className="navbar-toggler-icon"></span>
			 </button>
			 <div className="collapse navbar-collapse" id="navbarNav">
				<ul className="navbar-nav">
				   <li className="nav-item">
					  <a id="navbarNav1" className="nav-link" href="#Return">{t(`Return`)}</a>
				   </li>
				</ul>
			 </div>
		  </nav>		 
         {/* Search Fields*/}
         <div className="container-fluid mt-5">
            <h2  id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_1_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Advanced Search`)} <span className="toggle-icon">v</span></h2>
            <div  id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_1_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`PREAUCT Pre Auction Pool ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_1_0" type="text" className="form-control" placeholder="PREAUCT Pre Auction Pool ID"  
						onChange={PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_1_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_1_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter PREAUCT Pre Auction Pool ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`PREAUCT Auction Opportunity ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_1_1" type="text" className="form-control" placeholder="PREAUCT Auction Opportunity ID"  
						onChange={PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_1_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_1_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter PREAUCT Auction Opportunity ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '180ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Pool Name`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_1_2" type="text" className="form-control" placeholder="Pool Name"  
						onChange={PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_1_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_1_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '180ch' }}>
						 {t(`Enter Pool Name`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Token Type Code`)}
					 </div>
                     <div className="card-body" >
                        <select id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_1_3"   onChange={PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_1_3_Change} className="form-control" name="Token Type Code"  >
						  <option value="RENT_INCOME_TOKEN">RENT_INCOME_TOKEN</option>
						  <option value="REVENUE_SHARE_TOKEN">REVENUE_SHARE_TOKEN</option>
						  <option value="SALE_PROFIT_TOKEN">SALE_PROFIT_TOKEN</option>
						  <option value="EQUITY_APPRECIATION_TOKEN">EQUITY_APPRECIATION_TOKEN</option>
						  <option value="PREFERRED_EQUITY_TOKEN">PREFERRED_EQUITY_TOKEN</option>
						  <option value="COMMON_EQUITY_TOKEN">COMMON_EQUITY_TOKEN</option>
						  <option value="DEBT_NOTE_TOKEN">DEBT_NOTE_TOKEN</option>
						  <option value="HYBRID_TOKEN">HYBRID_TOKEN</option>
						  <option value="PRE_AUCTION_POOL_TOKEN">PRE_AUCTION_POOL_TOKEN</option>
						  <option value="POST_AUCTION_TOKENIZATION">POST_AUCTION_TOKENIZATION</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Token Type Code
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Pool Target Amount USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_2_0" type="text" className="form-control" placeholder="Pool Target Amount USD"  
						onChange={PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_2_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_2_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Pool Target Amount USD`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Pool Max Amount USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_2_1" type="text" className="form-control" placeholder="Pool Max Amount USD"  
						onChange={PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_2_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_2_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Pool Max Amount USD`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Minimum Pledge USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_2_2" type="text" className="form-control" placeholder="Minimum Pledge USD"  
						onChange={PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_2_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_2_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Minimum Pledge USD`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Maximum Pledge USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_2_3" type="text" className="form-control" placeholder="Maximum Pledge USD"  
						onChange={PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_2_3_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_2_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Maximum Pledge USD`)}
                     </div>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_3_0" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Investor Funds Held In Escrow`)} <input id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_3_0" type="checkbox" style={{ marginLeft: '5px' }}  onChange={PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_3_0_Change} 
					  checked={PREAUCT_PRE_AUCTION_POOL_S?.["3"]?.["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_3_0"] === "true" || PREAUCT_PRE_AUCTION_POOL_S?.["3"]?.["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_3_0"] === true} />
					</label>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_3_1" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Refund If Not Won`)} <input id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_3_1" type="checkbox" style={{ marginLeft: '5px' }}  onChange={PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_3_1_Change} 
					  checked={PREAUCT_PRE_AUCTION_POOL_S?.["3"]?.["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_3_1"] === "true" || PREAUCT_PRE_AUCTION_POOL_S?.["3"]?.["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_3_1"] === true} />
					</label>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_3_2" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Winning Bid Required For Tokenization`)} <input id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_3_2" type="checkbox" style={{ marginLeft: '5px' }}  onChange={PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_3_2_Change} 
					  checked={PREAUCT_PRE_AUCTION_POOL_S?.["3"]?.["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_3_2"] === "true" || PREAUCT_PRE_AUCTION_POOL_S?.["3"]?.["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_3_2"] === true} />
					</label>
                  </div>
               </div>
              {/* Tag to Pick a Date */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					  <div className="card-header" >
						 {t(`Pool Open Date`)}
					  </div>
					  <div className="card mb-3"  style={{ border: 'none'}}>
						 <div className="card-body"  style={{ border: 'none'}}>
							<input  id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_4_0" type="date"   
							onChange={PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_4_0_Change} style={{ borderColor: isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_4_0"] ? 'blue' : 'red' }} />
						 </div>
					  </div>
					  <div className="card-footer" >
						 Enter Pool Open Date
					  </div>
				  </div>
               </div>
              {/* Tag to Pick a Date */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					  <div className="card-header" >
						 {t(`Pool Close Date`)}
					  </div>
					  <div className="card mb-3"  style={{ border: 'none'}}>
						 <div className="card-body"  style={{ border: 'none'}}>
							<input  id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_4_1" type="date"   
							onChange={PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_4_1_Change} style={{ borderColor: isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_4_1"] ? 'blue' : 'red' }} />
						 </div>
					  </div>
					  <div className="card-footer" >
						 Enter Pool Close Date
					  </div>
				  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Pool Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_4_2"   onChange={PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_4_2_Change} className="form-control" name="Pool Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Open">Open</option>
						  <option value="Fully Subscribed">Fully Subscribed</option>
						  <option value="Closed">Closed</option>
						  <option value="Won Auction">Won Auction</option>
						  <option value="Lost Auction">Lost Auction</option>
						  <option value="Refunding">Refunding</option>
						  <option value="Cancelled">Cancelled</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Pool Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Submitted By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_5_0" type="text" className="form-control" placeholder="Submitted By"  
						onChange={PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_5_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_5_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Submitted By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Submitted At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_5_1" type="text" className="form-control" placeholder="Submitted At"  
						onChange={PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_5_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_5_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Submitted At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Reviewed By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_5_2" type="text" className="form-control" placeholder="Reviewed By"  
						onChange={PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_5_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_5_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Reviewed By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Reviewed At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_5_3" type="text" className="form-control" placeholder="Reviewed At"  
						onChange={PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_5_3_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_5_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Reviewed At`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Approval Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_5_4"   onChange={PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_5_4_Change} className="form-control" name="Approval Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Submitted">Submitted</option>
						  <option value="Under Review">Under Review</option>
						  <option value="Revision Requested">Revision Requested</option>
						  <option value="Approved">Approved</option>
						  <option value="Rejected">Rejected</option>
						  <option value="Withdrawn">Withdrawn</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Approval Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '3000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Approval Notes`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_5_5" type="text" className="form-control" placeholder="Approval Notes"  
						onChange={PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_5_5_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_5_5"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '3000ch' }}>
						 {t(`Enter Approval Notes`)}
                     </div>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_0" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Sales Map Listing Enabled`)} <input id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_0" type="checkbox" style={{ marginLeft: '5px' }}  onChange={PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_0_Change} 
					  checked={PREAUCT_PRE_AUCTION_POOL_S?.["7"]?.["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_0"] === "true" || PREAUCT_PRE_AUCTION_POOL_S?.["7"]?.["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_0"] === true} />
					</label>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Sales Map Listing Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_1"   onChange={PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_1_Change} className="form-control" name="Sales Map Listing Status"  >
						  <option value="Not Listed">Not Listed</option>
						  <option value="Pre-Listing Draft">Pre-Listing Draft</option>
						  <option value="Preview Only">Preview Only</option>
						  <option value="Listed - Not Investable">Listed - Not Investable</option>
						  <option value="Listed - Investment Open">Listed - Investment Open</option>
						  <option value="Paused">Paused</option>
						  <option value="Closed">Closed</option>
						  <option value="Archived">Archived</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Sales Map Listing Status
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Sales Map First Display Trigger`)}
					 </div>
                     <div className="card-body" >
                        <select id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_2"   onChange={PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_2_Change} className="form-control" name="Sales Map First Display Trigger"  >
						  <option value="Asset Profile Created">Asset Profile Created</option>
						  <option value="Map Minimum Data Ready">Map Minimum Data Ready</option>
						  <option value="Offering Draft Created">Offering Draft Created</option>
						  <option value="Compliance Pre-Review Started">Compliance Pre-Review Started</option>
						  <option value="Offering Submitted">Offering Submitted</option>
						  <option value="Offering Approved">Offering Approved</option>
						  <option value="Manual Publish">Manual Publish</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Sales Map First Display Trigger
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '180ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Sales Map Public Title`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_3" type="text" className="form-control" placeholder="Sales Map Public Title"  
						onChange={PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_3_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '180ch' }}>
						 {t(`Enter Sales Map Public Title`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '1000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Sales Map Public Summary`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_4" type="text" className="form-control" placeholder="Sales Map Public Summary"  
						onChange={PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_4_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '1000ch' }}>
						 {t(`Enter Sales Map Public Summary`)}
                     </div>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_5" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Sales Map Minimum Data Ready`)} <input id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_5" type="checkbox" style={{ marginLeft: '5px' }}  onChange={PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_5_Change} 
					  checked={PREAUCT_PRE_AUCTION_POOL_S?.["7"]?.["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_5"] === "true" || PREAUCT_PRE_AUCTION_POOL_S?.["7"]?.["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_5"] === true} />
					</label>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Sales Map Security Display Level`)}
					 </div>
                     <div className="card-body" >
                        <select id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_6"   onChange={PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_6_Change} className="form-control" name="Sales Map Security Display Level"  >
						  <option value="Minimal Public">Minimal Public</option>
						  <option value="Public After Compliance Precheck">Public After Compliance Precheck</option>
						  <option value="Investor Login Required">Investor Login Required</option>
						  <option value="KYC Required">KYC Required</option>
						  <option value="Accreditation Required">Accreditation Required</option>
						  <option value="Admin Only">Admin Only</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Sales Map Security Display Level
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Sales Map Risk Display Level`)}
					 </div>
                     <div className="card-body" >
                        <select id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_7"   onChange={PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_7_Change} className="form-control" name="Sales Map Risk Display Level"  >
						  <option value="No Risk Shown">No Risk Shown</option>
						  <option value="Color Only">Color Only</option>
						  <option value="Summary Risk">Summary Risk</option>
						  <option value="Full Risk Score">Full Risk Score</option>
						  <option value="Compliance Approved Risk Only">Compliance Approved Risk Only</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Sales Map Risk Display Level
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Sales Map Boundary Display Mode`)}
					 </div>
                     <div className="card-body" >
                        <select id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_8"   onChange={PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_8_Change} className="form-control" name="Sales Map Boundary Display Mode"  >
						  <option value="Show Exact Boundary">Show Exact Boundary</option>
						  <option value="Show Approximate Boundary">Show Approximate Boundary</option>
						  <option value="Show Center Pin Only">Show Center Pin Only</option>
						  <option value="Show Bounding Box">Show Bounding Box</option>
						  <option value="Hide Boundary Until Approved">Hide Boundary Until Approved</option>
						  <option value="Hide Full Location">Hide Full Location</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Sales Map Boundary Display Mode
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Sales Map Call To Action Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_9"   onChange={PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_9_Change} className="form-control" name="Sales Map Call To Action Status"  >
						  <option value="View Only">View Only</option>
						  <option value="Join Waitlist">Join Waitlist</option>
						  <option value="Request Access">Request Access</option>
						  <option value="Start KYC">Start KYC</option>
						  <option value="Reserve Interest">Reserve Interest</option>
						  <option value="Invest Now">Invest Now</option>
						  <option value="Closed">Closed</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Sales Map Call To Action Status
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Record Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_9_0"   onChange={PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_9_0_Change} className="form-control" name="Record Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Archived">Archived</option>
						  <option value="Deleted">Deleted</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Record Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_9_1" type="text" className="form-control" placeholder="Created By"  
						onChange={PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_9_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_9_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Created By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_9_2" type="text" className="form-control" placeholder="Created At"  
						onChange={PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_9_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_9_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Created At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_9_3" type="text" className="form-control" placeholder="Updated By"  
						onChange={PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_9_3_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_9_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Updated By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_9_4" type="text" className="form-control" placeholder="Updated At"  
						onChange={PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_9_4_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_9_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
		 {/* Query Result*/}
         <div className="container-fluid mt-5">
            <h2 style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Query Result`)}</h2>
            <div className="row">
			                 {/* Table with Bootstrap Cards and DataTables */}
			   <button onClick={() => handleAddRow('9')}  style={{ display: 'none' }} className="btn btn-primary">
				  {t('Add Row')}
			   </button>
               <table id="Table9" className="table">
                  <thead>
                     <tr>
					                         <th>{t(`PREAUCT Pre Auction Pool ID`)}</th>
                        <th>{t(`PREAUCT Auction Opportunity ID`)}</th>
                        <th>{t(`Pool Name`)}</th>
                        <th>{t(`Token Type Code`)}</th>
                        <th>{t(`Pool Target Amount USD`)}</th>
                        <th>{t(`Pool Max Amount USD`)}</th>
                        <th>{t(`Minimum Pledge USD`)}</th>
                        <th>{t(`Maximum Pledge USD`)}</th>
                        <th>{t(`Investor Funds Held In Escrow`)}</th>
                        <th>{t(`Refund If Not Won`)}</th>
                        <th>{t(`Winning Bid Required For Tokenization`)}</th>
                        <th>{t(`Pool Open Date`)}</th>
                        <th>{t(`Pool Close Date`)}</th>
                        <th>{t(`Pool Status`)}</th>
                        <th>{t(`Submitted By`)}</th>
                        <th>{t(`Submitted At`)}</th>
                        <th>{t(`Reviewed By`)}</th>
                        <th>{t(`Reviewed At`)}</th>
                        <th>{t(`Approval Status`)}</th>
                        <th>{t(`Approval Notes`)}</th>
                        <th>{t(`Sales Map Listing Enabled`)}</th>
                        <th>{t(`Sales Map Listing Status`)}</th>
                        <th>{t(`Sales Map First Display Trigger`)}</th>
                        <th>{t(`Sales Map Public Title`)}</th>
                        <th>{t(`Sales Map Public Summary`)}</th>
                        <th>{t(`Sales Map Minimum Data Ready`)}</th>
                        <th>{t(`Sales Map Security Display Level`)}</th>
                        <th>{t(`Sales Map Risk Display Level`)}</th>
                        <th>{t(`Sales Map Boundary Display Mode`)}</th>
                        <th>{t(`Sales Map Call To Action Status`)}</th>
                        <th>{t(`Record Status`)}</th>
                        <th>{t(`Created By`)}</th>
                        <th>{t(`Created At`)}</th>
                        <th>{t(`Updated By`)}</th>
                        <th>{t(`Updated At`)}</th>

                     </tr>
                  </thead>
                  <tbody>
				    {PREAUCT_PRE_AUCTION_POOL_S.map((e, i) => {
                     return<tr  onClick={((e) => handleSingleClick(e,"TR"+e[`id`]))}  onDoubleClick={((e) => handleDoubleClick(e,"TR"+e[`id`]))} key={(e.id || i)} id={"TR"+(e.id || i)}>
						<td>{e["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_1_0"]} </td>
						<td>{e["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_1_1"]} </td>
						<td>{e["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_1_2"]} </td>
						<td>{e["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_1_3"]} </td>
						<td>{e["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_2_0"]} </td>
						<td>{e["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_2_1"]} </td>
						<td>{e["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_2_2"]} </td>
						<td>{e["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_2_3"]} </td>
						<td>{e["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_3_0"]} </td>
						<td>{e["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_3_1"]} </td>
						<td>{e["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_3_2"]} </td>
						<td>{e["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_4_0"]} </td>
						<td>{e["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_4_1"]} </td>
						<td>{e["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_4_2"]} </td>
						<td>{e["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_5_0"]} </td>
						<td>{e["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_5_1"]} </td>
						<td>{e["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_5_2"]} </td>
						<td>{e["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_5_3"]} </td>
						<td>{e["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_5_4"]} </td>
						<td>{e["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_5_5"]} </td>
						<td>{e["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_0"]} </td>
						<td>{e["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_1"]} </td>
						<td>{e["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_2"]} </td>
						<td>{e["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_3"]} </td>
						<td>{e["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_4"]} </td>
						<td>{e["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_5"]} </td>
						<td>{e["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_6"]} </td>
						<td>{e["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_7"]} </td>
						<td>{e["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_8"]} </td>
						<td>{e["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_7_9"]} </td>
						<td>{e["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_9_0"]} </td>
						<td>{e["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_9_1"]} </td>
						<td>{e["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_9_2"]} </td>
						<td>{e["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_9_3"]} </td>
						<td>{e["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_PRE_AUCTION_POOL_9_4"]} </td>

                     </tr>	
					})}
                  </tbody>
               </table>
							   
            </div>
         </div>
  </>;
};

export default PREAUCT_Pre_Auction_Pool_S;  